import { mapGetters } from "vuex";
import FavoriteApi from "../../../services/api/favoritesApi.js";

const FavoriteApiService = new FavoriteApi();
export default {
  props: ["isFav", "id", "isProduct", "isButton", "buttonClass", "trackingInfo"],

  data() {
    return {
      IS_fave: this.isFav,
      faveTypeToggle: this.isProduct,
      elementTypeToggle: !this.isButton,
    };
  },

  methods: {
    handleFavoriteClick,
  },

  computed: {
    testIdPrefix() {
      return this.isProduct ? "product" : "brand";
    },
    displayFavoriteToggle() {
      return this.user === null || this.user.role === "RETAILER";
    },
    toggleClickEnabled() {
      return this.user && this.user.role === "RETAILER";
    },
    ...mapGetters({
      user: "userState",
    }),
  },
};

function handleFavoriteClick() {
  const properties = {
      ...this.trackingInfo,
      "Page name": this.$utils.constants.routeDict[this.$route.name],
      "Page type": this.$utils.constants.routeDict[this.$route.name],
    },
    action = this.isProduct ? "Favorite Product" : "Favorite Brand";

  if (this.toggleClickEnabled) {
    if (this.faveTypeToggle) {
      FavoriteApiService.favoriteProductToggle(this.id);
    } else {
      FavoriteApiService.favoriteBrandToggle(this.id);
    }
    this.IS_fave = !this.IS_fave;

    if (this.IS_fave) {
      this.$ma.trackEvent({
        action: action,
        properties: properties,
      });
    }
  } else {
    this.$eventBus.$emit("apply-modal-unregistered", null);
  }
}
